const readMore = {
  wrap: document.querySelectorAll('.jsReadMore') as NodeListOf<HTMLElement>,
  desc: document.querySelectorAll('.jsDesc') as NodeListOf<HTMLElement>,

  init() {
    this.setBtn();
    this.setShowMore();
  },

  setBtn() {
    this.wrap.forEach((item) => {
      const elWrap = item.querySelector('.jsReadMoreWrap') as HTMLElement;
      const elBody = item.querySelector('.jsReadMoreBody') as HTMLElement;
      const btn = item.querySelector('.jsReadMoreTrigger') as HTMLElement;
      const height = elBody.offsetHeight;
      const itemHeight = elWrap.offsetHeight;

      if (!btn) return;
      if (height <= itemHeight) {
        btn.classList.add('d-none');
      }
      btn.addEventListener('click', () => {
        if (btn.dataset.open === 'false') {
          btn.dataset.open = 'true';
          elWrap.style.maxHeight = height + 30 + 'px';
          btn.innerText = 'Read Less ';
        } else {
          btn.dataset.open = 'false';
          elWrap.style.maxHeight = itemHeight + 'px';
          btn.innerText = 'Read More';
        }
      });
    });
  },

  setShowMore() {
    this.desc.forEach(item => {
      const descWrap = item.querySelector('.jsDescWrap') as HTMLElement; 
      const descBtn = item.querySelector('.jsShowMore') as HTMLElement;
      const parentAcc = item.parentElement?.parentElement as HTMLElement;
      const mainAccord = item.parentElement?.parentElement?.parentElement as HTMLElement;
  
      descBtn.addEventListener('click', () => {
        if(descBtn.dataset.open === 'false') {
          descBtn.dataset.open = 'true';
          descBtn.textContent = 'Show Less';
          descWrap.classList.remove('activeClass');
        
        } else {
          descBtn.dataset.open = 'false';
          descBtn.textContent = 'Show More';
          descWrap.classList.add('activeClass');
        }
      }); 

      if(descWrap.offsetHeight > 430) {
        descBtn.classList.remove('d-none');
        descWrap.classList.add('activeClass');
      } else {
        descBtn.classList.add('d-none');
        descWrap.classList.remove('activeClass');
      }

    });
  }
};

export default readMore;
